import { store } from '@/decorators/store';
import { CallSource } from '@/entities/CallSource';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'CallSourceStore' })
export class CallSourceStore extends AbstractEntityStore<CallSource> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
